import {combineReducers} from '@reduxjs/toolkit'

import {generalSlice} from '../features/general/generalSlice'
import {configurationModelsDataSlice} from '../features/configurationsModelsData/configurationModelsDataSlice'
import {filterValuesSlice} from '../features/filterValues/filterValuesSlice'
import {dealerFormDataSlice} from '../features/dealerFormData/dealerFormDataSlice'
import {layersHandleSlice} from '../features/layersHandle/layersHandleSlice'
import {dealerSlice} from '../features/dealers/dealerSlice'

const rootReducer: any = combineReducers({
    general: generalSlice.reducer,
    configurationModelsData: configurationModelsDataSlice.reducer,
    filterValues: filterValuesSlice.reducer,
    dealerFormData: dealerFormDataSlice.reducer,
    layersHandle: layersHandleSlice.reducer,
    dealer: dealerSlice.reducer,
})

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
